module.exports = __webpack_public_path__ + "img/anewitem-requests.866b2d98.svg";